import store from "@/store";
const config = {
  // 请求超时时间
  timeout: 30000,
  // 错误码
  RESPONSE_CODE: {
    400: "请求参数错误",
    403: "拒绝访问",
    404: "请求超时",
    500: "服务器内部错误",
    501: "服务未实现",
    502: "网关错误",
    503: "服务不可用",
    504: "网关超时",
    505: "HTTP版本不受支持",
  },

  // token 后期可更换名称
  TOKEN_KEY: "token",

  // 代理的URL
  proxyUrl: "",
  // 加密信息
  key: "76a6302C5822490bb06edc12",
  iv: "ed27297d",

  serviceListUrl: "https://daydaytrades.oss-cn-hongkong.aliyuncs.com/ServiceInfo/s_servicelist.json", // 主服务器列表URL
  serviceCodeUrl: (serviceCode) =>
    `https://daydaytrades.oss-cn-hongkong.aliyuncs.com/ServiceInfo/${serviceCode}.json`, // 根据ServiceCode拼接的URL
};

const defaultBaseUrl = "https://api.daydaytrades.com";

const getServerUrls = () => {
  const selectedServer = store.getters['server/getSelectedServer'] ? store.getters['server/getSelectedServer'].url : defaultBaseUrl; // 从 Vuex 获取服务器地址
  return {
    http: `${selectedServer}/user/`,
    payhttp: `${selectedServer}/payment/`,
    tradehttp: `${selectedServer}/trade/`,
    stradehttp: `${selectedServer}/strade/`,
    hqhttp: `${selectedServer}/quote/`,
    newshttp: `${selectedServer}/news/`,
    activityhttp: `${selectedServer}/activity/`,
    followorderhttp: `${selectedServer}/trade/`,
    proxyhttp: `${selectedServer}/user/`,
  };
};


// 正确导出方式
export { config, getServerUrls, defaultBaseUrl };
